import { baseApi } from './baseApi';

export const inventoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getStockLevels: builder.query({
      query: (params) => ({
        url: '/inventory/levels',
        params,
      }),
      providesTags: ['Inventory'],
    }),
    getProductBatches: builder.query({
      query: (params) => ({
        url: '/inventory/batches',
        params,
      }),
      providesTags: ['Inventory'],
    }),
    adjustStock: builder.mutation({
      query: (data) => ({
        url: '/inventory/adjust',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Inventory'],
    }),
    updateReorderPoint: builder.mutation({
      query: ({ id, reorderPoint }) => ({
        url: `/inventory/levels/${id}`,
        method: 'PATCH',
        body: { reorderPoint },
      }),
      invalidatesTags: ['Inventory'],
    }),
    getStockMovements: builder.query({
      query: (params) => ({
        url: '/inventory/movements',
        params,
      }),
      providesTags: ['Inventory'],
    }),
    getLocations: builder.query({
      query: () => '/inventory/locations',
      providesTags: ['Inventory'],
    }),
    createLocation: builder.mutation({
      query: (data) => ({
        url: '/inventory/locations',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Inventory'],
    }),
    updateLocation: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/inventory/locations/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Inventory'],
    }),
    deleteLocation: builder.mutation({
      query: (id) => ({
        url: `/inventory/locations/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Inventory'],
    }),
    getStockTransfers: builder.query({
      query: (params) => ({
        url: '/inventory/transfers',
        params,
      }),
      providesTags: ['Inventory'],
    }),
    getStockTransferById: builder.query({
      query: (id) => `/inventory/transfers/${id}`,
      providesTags: ['Inventory'],
    }),
    createStockTransfer: builder.mutation({
      query: (data) => ({
        url: '/inventory/transfers',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Inventory'],
    }),
    deleteStockTransfer: builder.mutation({
      query: (id) => ({
        url: `/inventory/transfers/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Inventory'],
    }),
    getConsumptions: builder.query({
      query: (params) => ({
        url: '/consumptions',
        params,
      }),
      providesTags: ['Inventory'],
    }),
    getConsumptionById: builder.query({
      query: (id) => `/consumptions/${id}`,
      providesTags: ['Inventory'],
    }),
    createConsumption: builder.mutation({
      query: (data) => ({
        url: '/consumptions',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Inventory'],
    }),
    getProductions: builder.query({
      query: (params) => ({
        url: '/inventory/productions',
        params,
      }),
      providesTags: ['Inventory'],
    }),
    getProductionById: builder.query({
      query: (id) => `/inventory/productions/${id}`,
      providesTags: ['Inventory'],
    }),
    createProduction: builder.mutation({
      query: (data) => ({
        url: '/inventory/productions',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Inventory'],
    }),
  }),
});

export const {
  useGetStockLevelsQuery,
  useGetProductBatchesQuery,
  useLazyGetProductBatchesQuery,
  useAdjustStockMutation,
  useUpdateReorderPointMutation,
  useGetStockMovementsQuery,
  useGetLocationsQuery,
  useCreateLocationMutation,
  useUpdateLocationMutation,
  useDeleteLocationMutation,
  useGetStockTransfersQuery,
  useGetStockTransferByIdQuery,
  useCreateStockTransferMutation,
  useDeleteStockTransferMutation,
  useGetConsumptionsQuery,
  useGetConsumptionByIdQuery,
  useCreateConsumptionMutation,
  useGetProductionsQuery,
  useGetProductionByIdQuery,
  useCreateProductionMutation,
} = inventoryApi;
